// ======================================================================
// File Name       : ArchivementAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import _ from 'lodash';
import { REPORT_STATUS } from '../../constants/ArchivementConstant';
import { MANAGEMENT_AUTHORITY_TYPE } from '../../constants/AuthorityConstant';
import { SELECT_REPORT_RESPONSE_DATA, SELECT_TARGET_DATA } from '../../constants/index';
import { USER_CREATE_TYPE } from '../../constants/UserConstants';
import * as archivementRequests from '../httpRequests/archivement';
import * as archivementActionCreators from './../actionCreators/archivement';

export function searchUser(searchParam = {}, isDetail) {
  return (dispatch) => {
    const param = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
    };
    return archivementRequests
      .getAuthorityList(param)
      .then((camelizeJson) => {
        dispatch(archivementActionCreators.receiveAuthorityList(camelizeJson));

        const { managementAuthorityList } = camelizeJson;
        const managementAuthoritySecernIds = [];
        managementAuthorityList.forEach((managementAuthoritys) => {
          if (
            managementAuthoritys.managementFunctionAuthorityInfo &&
            managementAuthoritys.managementFunctionAuthorityInfo.scoringManagementAuthority &&
            (managementAuthoritys.managementFunctionAuthorityInfo.scoringManagementAuthority === MANAGEMENT_AUTHORITY_TYPE.REFERENCE ||
              managementAuthoritys.managementFunctionAuthorityInfo.scoringManagementAuthority === MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT)
          ) {
            const { managementAuthoritySecernId } = managementAuthoritys;
            managementAuthoritySecernIds.push(managementAuthoritySecernId);
          }
        });

        return dispatch(getUserList(searchParam, managementAuthoritySecernIds, isDetail));
      });
  };
}

export function getUserList(searchParam, managementAuthoritySecernIds, isDetail) {
  return (dispatch) => {
    const param = {
      selectTargetData: searchParam.selectTargetData,
      searchInfo: {
        managementAuthorityList: managementAuthoritySecernIds,
        loginId: searchParam.searchInfo && searchParam.searchInfo.loginId,
        userName: searchParam.searchInfo && searchParam.searchInfo.userName,
        userSortType: searchParam.searchInfo && searchParam.searchInfo.userSortType,
        ascendingDescendingSort:
          searchParam.searchInfo && searchParam.searchInfo.ascendingDescendingSort,
        startPosition: searchParam.searchInfo && searchParam.searchInfo.startPosition,
        returnMaxNum: searchParam.searchInfo && searchParam.searchInfo.returnMaxNum,
        userSecernIdList: searchParam.searchInfo.userSecernIdList, // Step 9.0.0
        userCreateType: USER_CREATE_TYPE.DEFINED_AND_REPRESENTATIVE_USER,
      },
    };

    return archivementRequests
      .getUserList(param)
      .then((camelizeJson) => {
        if (!isDetail) {
          dispatch(archivementActionCreators.receiveUserList(camelizeJson, searchParam));
          const { userList } = camelizeJson;

          const userSecernIds = [];
          userList.forEach((userInfo) => {
            const { userSecernId } = userInfo;
            userSecernIds.push(userSecernId);
          });
          if (userSecernIds && userSecernIds.length > 0) {
            dispatch(getReportOperationCount(userSecernIds, searchParam));
          }
        } else {
          dispatch(archivementActionCreators.receiveMappingUser(camelizeJson));
        }
      });
  };
}

export function getReportOperationCount(userSecernIds, searchParam) {
  return (dispatch) => {
    const param = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
      selectReportResponseData: SELECT_REPORT_RESPONSE_DATA.CHECKER_USER_LIST,
      searchInfo: {
        reportStatusList: [REPORT_STATUS.APPROVAL, REPORT_STATUS.RESULT_RETURN],
        checkerUserList: userSecernIds,
        reportApprovalDateFrom: searchParam.searchInfo.reportApprovalDateFrom,
        reportApprovalDateTo: searchParam.searchInfo.reportApprovalDateTo,
      },
    };

    return archivementRequests
      .getReportOperationCount(param)
      .then(camelizeJson =>
        dispatch(archivementActionCreators.receiveReportOperationCount(camelizeJson)),
      );
  };
}

export function getReportOperationList(searchParam = {}, userSecernId) {
  return (dispatch) => {
    const param = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
      searchInfo: {
        checkerUserList: searchParam.searchInfo && searchParam.searchInfo.checkerUserList,
        reportStatusList: [REPORT_STATUS.APPROVAL, REPORT_STATUS.RESULT_RETURN],
        reportApprovalDateFrom:
          searchParam.searchInfo && searchParam.searchInfo.reportApprovalDateFrom,
        reportApprovalDateTo: searchParam.searchInfo && searchParam.searchInfo.reportApprovalDateTo,
        ascendingDescendingSort:
          searchParam.searchInfo && searchParam.searchInfo.ascendingDescendingSort,
        reportHistorySortType:
          searchParam.searchInfo && searchParam.searchInfo.reportHistorySortType,
        startPosition: searchParam.searchInfo && searchParam.searchInfo.startPosition,
        returnMaxNum: searchParam.searchInfo && searchParam.searchInfo.returnMaxNum,
      },
    };

    return archivementRequests
      .getReportOperationList(param)
      .then((camelizeJson) => {
        dispatch(archivementActionCreators.receiveReportOperationList(camelizeJson));

        const { reportList } = camelizeJson;

        const userSecernIds = userSecernId ? [userSecernId] : [];
        reportList.forEach((reportInfo) => {
          const { submitterUserSecernId, checkerUserSecernId } = reportInfo;
          userSecernIds.push(submitterUserSecernId);
          userSecernIds.push(checkerUserSecernId);
        });
        const paramSearchUser = {
          selectTargetData: SELECT_TARGET_DATA.DATA,
          searchInfo: {
            userSecernIdList: _.uniq(userSecernIds), // Step 9.0.0
          },
        };
        dispatch(getUserList(paramSearchUser, [], true));
      });
  };
}
